import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { DefaultLogoUrl } from '@racemap/utilities/consts/events';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { ID } from '@racemap/utilities/types/utils';
import type { Immutable } from 'immer';
import type { FC } from 'react';
import type { CurrentEvent } from '../../../store/events/events_reducers';

type Props = {
  eventId?: ID;
  event?: Immutable<CurrentEvent | RacemapEvent>;
  src?: string;
  size?: number;
  rounded?: boolean | number;
};

export const EventLogo: FC<Props> = ({ eventId, event, src, size = 80, rounded = false }) => {
  let finalSrc = DefaultLogoUrl;
  if (src != null) {
    finalSrc = src;
  } else if (event != null && event.images?.app != null) {
    finalSrc = event.images.app;
  } else if (eventId != null) {
    finalSrc = `/api/events/${eventId}/logo`;
  }

  return (
    <CropContainer rounded={rounded}>
      <Logo src={finalSrc} alt="eventLogo" size={size} />
    </CropContainer>
  );
};

// Helper function to determine border-radius value
function getBorderRadius(rounded: boolean | number): string {
  if (typeof rounded === 'number') {
    return `${rounded}px`;
  }
  if (typeof rounded === 'boolean' && rounded) {
    return '15px';
  }
  return 'unset';
}

const CropContainer = styled.div<{ rounded: boolean | number }>`
  width: fit-content;
  height: fit-content;
  overflow: hidden;
  border: solid 1px ${RacemapColors.Gray};
  border-radius: ${({ rounded }) => getBorderRadius(rounded)};
`;

const Logo = styled.img<{ size: number }>`
  width: ${({ size }) => `${size}px`};
  background: white;
  display: block;
  margin: -2px -2px -2px -2px;
`;
